export default __webpack_public_path__ + "static/media/alef_logo.4b35bbd2.png";